module.exports = {
      id: "newslettericon-usage",
      viewBox: "0 0 48 47.861",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#newslettericon",
      toString: function () {
        return this.url;
      }
    }